import axios from "axios";

// If your app uses setAuthToken(token) globally,
// axios should already have Authorization set on defaults.
// If not, this fallback ensures Authorization is included.
const getAuthHeaders = () => {
  const token = localStorage.getItem("jwtToken");
  return token ? { Authorization: token } : {};
};

export const fetchCourseResources = ({ courseKey, includeInactive = false } = {}) => {
  const params = { includeInactive: !!includeInactive };
  if (courseKey) params.courseKey = courseKey;

  return axios.get("/api/course-resources", {
    params,
    headers: getAuthHeaders(),
  });
};


export const createCourseResource = (formData) => {
  return axios.post("/api/course-resources", formData, {
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });
};

export const updateCourseResource = (id, formData) => {
  return axios.patch(`/api/course-resources/${id}`, formData, {
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteCourseResource = (id) => {
  return axios.delete(`/api/course-resources/${id}`, {
    headers: getAuthHeaders(),
  });
};
